import { render } from "./OrganizationManagement.vue?vue&type=template&id=78b1f238&scoped=true"
import script from "./OrganizationManagement.vue?vue&type=script&lang=js"
export * from "./OrganizationManagement.vue?vue&type=script&lang=js"

import "./OrganizationManagement.vue?vue&type=style&index=0&id=78b1f238&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78b1f238"]])

export default __exports__